import React from "react";

/**
 * AnyPAKU logo — Futura wordmark + decorative blue/orange swirl
 * - Wordmark: navy "ANYP" + orange "A" + navy "KU"
 * - Below: "Muuttopalvelut · Kuljetukset"
 */
export const AnypakuLogo = ({
  size = 64,
  withSwirl = false,
  withTagline = false,
  withVan = false,
  className = "",
}) => {
  const navy = "#1A4B8C";
  const orange = "#F58220";

  return (
    <div
      className={className}
      style={{
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: size * 0.06,
        position: "relative",
        padding: withSwirl ? size * 0.45 : 0,
      }}
    >
      {withSwirl && (
        <svg
          viewBox="0 0 400 220"
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            pointerEvents: "none",
            zIndex: 0,
          }}
        >
          <path
            d="M 60 110 C 60 40, 160 20, 240 35 C 330 50, 360 110, 340 160 C 320 205, 230 215, 160 200"
            fill="none"
            stroke={navy}
            strokeWidth="14"
            strokeLinecap="round"
          />
          <path
            d="M 80 130 C 90 70, 180 60, 250 75 C 310 90, 320 140, 300 170"
            fill="none"
            stroke={orange}
            strokeWidth="10"
            strokeLinecap="round"
          />
          <path
            d="M 290 158 L 312 168 L 296 188"
            fill="none"
            stroke={orange}
            strokeWidth="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}

      <span
        style={{
          fontFamily: "'Futura', 'Futura PT', 'Jost', sans-serif",
          fontWeight: 800,
          fontSize: size,
          letterSpacing: -size * 0.005,
          lineHeight: 0.9,
          color: navy,
          position: "relative",
          zIndex: 1,
          textTransform: "uppercase",
        }}
      >
        ANYP<span style={{ color: orange }}>A</span>KU
      </span>

      {withTagline && (
        <span
          style={{
            fontFamily: "'Futura', 'Futura PT', 'Jost', sans-serif",
            fontWeight: 500,
            fontSize: size * 0.22,
            color: navy,
            letterSpacing: 0.5,
            position: "relative",
            zIndex: 1,
          }}
        >
          Muuttopalvelut · Kuljetukset
        </span>
      )}

      {withVan && (
        <svg
          viewBox="0 0 240 130"
          width={size * 1.1}
          height={size * 0.6}
          style={{ marginTop: size * 0.1, position: "relative", zIndex: 1 }}
        >
          <path
            d="M 36 24 L 148 24 L 148 56 L 196 56 C 204 56 209 60 213 66 L 226 88 C 230 94 230 100 224 102 L 36 102 Z"
            fill={navy}
          />
          <rect x="62" y="44" width="22" height="22" rx="2" fill={orange} />
          <circle cx="70" cy="104" r="18" fill={navy} />
          <circle cx="70" cy="104" r="9" fill={orange} />
          <circle cx="196" cy="104" r="18" fill={navy} />
          <circle cx="196" cy="104" r="9" fill={orange} />
        </svg>
      )}
    </div>
  );
};

export default AnypakuLogo;
